module.exports = __webpack_public_path__ + "static/media/rw.c9d69761.svg";